'use client';

import { AgencyCalendarIcon } from '@curology/ui-components-web/react/Icon/icons/AgencyCalendarIcon';
import { BellIcon } from '@curology/ui-components-web/react/Icon/icons/BellIcon';
import { CircleCheckIcon } from '@curology/ui-components-web/react/Icon/icons/CircleCheckIcon';
import { CrossIcon } from '@curology/ui-components-web/react/Icon/icons/CrossIcon';
import { FormulaChangeIcon } from '@curology/ui-components-web/react/Icon/icons/FormulaChangeIcon';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

import { useDataProvider } from '@/components/flow/components/DataProvider/useDataProvider';
import { useFlowContext } from '@/components/flow/hooks/useFlowContext';
import { DATA_KEYS } from '@/consts/dataKeys';

export const SubscriptionCallouts = () => {
  const { brand } = useFlowContext();
  const { flags } = useDataProvider(DATA_KEYS.productSelection);

  return (
    <div>
      {!flags.curologySkinPreShipmentNotification ? (
        <div className="cur-flex cur-items-center cur-justify-center">
          {brand === 'agency' ? (
            <AgencyCalendarIcon className="cur-mr-2" />
          ) : (
            <FormulaChangeIcon className="cur-mr-2" size="sm" />
          )}
          <Typography size="body">
            Edit your subscription box or cancel anytime
          </Typography>
        </div>
      ) : (
        <div className="cur-flex cur-gap-2">
          <div className="cur-flex-col cur-items-center cur-justify-center">
            <CircleCheckIcon className="cur-mr-2 cur-mb-3" size="sm" />
            <Typography size="body">
              Choose the products you want in your box
            </Typography>
          </div>
          <div className="cur-flex-col cur-items-center cur-justify-center">
            <BellIcon className="cur-mr-2 cur-mb-3" size="sm" />
            <Typography size="body">
              We&apos;ll remind you before your next shipment
            </Typography>
          </div>
          <div className="cur-flex-col cur-items-center cur-justify-center">
            <CrossIcon className="cur-mr-2 cur-mb-3" size="sm" />
            <Typography size="body">
              Easily skip, reschedule or cancel anytime
            </Typography>
          </div>
        </div>
      )}
    </div>
  );
};
